import { ITag } from './article'

export enum MediaTypeEnum {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  EMBEDDEDVIDEO = 'EMBEDDEDVIDEO',
  AUDIO = 'AUDIO',
}

export interface IMedia {
  type: MediaTypeEnum
  fileUrl: string
  fileThumbUrl: string
  title: string
  productTime?: string
  innerDescription: string
  place: string
  source: string
  author: string
  tags: ITag[]
}
